import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { combineLatest, EMPTY } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { LanguagesService } from 'src/app/domain/services';
import { environment } from '../../../../environments/environment';
import { AuthPopupService, AuthService } from '../../../auth/services';
import {
    ProviderLinkService,
    SwitchLanguageService
} from '../../../core/services';
import { ClientService } from '../../../domain/services/client.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
    @Output() public sidenavToggle = new EventEmitter();

    languages = [
        { code: 'en', name: 'English' },
        { code: 'es', name: 'Español' }
    ];
    get selectedLanguage(): string | null {
        return sessionStorage.getItem('selectedLanguage');
    }

    get selectedLanguageName(): string {
        return this.selectedLanguage === 'es' ? 'Español' : 'English';
    }

    user$ = this._auth.user$;

    clientLogoPath: string | undefined;

    clientIsEnabled: boolean = false;

    constructor(
        private service: TranslocoService,
        public router: Router,
        private readonly _auth: AuthService,
        private readonly _authPopup: AuthPopupService,
        private readonly _client: ClientService,
        private readonly _switchLanguage: SwitchLanguageService,
        private readonly _language: LanguagesService,
        private readonly _providerLink: ProviderLinkService
    ) {}

    get isSignedIn(): boolean {
        return this._auth.isSignedIn;
    }

    ngOnInit() {
        this._auth.user$.subscribe((user) => {
            let selectedLanguage = undefined;
            if (user?.preferredLanguage?.startsWith('en')) {
                selectedLanguage = 'en';
            } else if (user?.preferredLanguage?.startsWith('es')) {
                selectedLanguage = 'es';
            } else if (this.selectedLanguage === null) {
                selectedLanguage = 'en';
            } else {
                selectedLanguage = this.selectedLanguage;
            }
            sessionStorage.setItem(
                'selectedLanguage',
                selectedLanguage ?? 'en'
            );
            if (this.service.getActiveLang() !== this.selectedLanguage)
                this.service.setActiveLang(this.selectedLanguage!);
        });
        this._client.latest.subscribe((client) => {
            this.clientIsEnabled = client?.isEnabled == true;
            this.clientLogoPath = client?.logoPath
                ? environment.apiUrl + client.logoPath
                : undefined;
        });
    }

    public onToggleSidenav = () => {
        this.sidenavToggle.emit();
    };

    public selectLanguage(val: string) {
        if (this.isSignedIn) {
            combineLatest([
                this._auth.user$.pipe(take(1)),
                this._language.languages$.pipe(take(1))
            ])
                .pipe(
                    switchMap(([user, languages]) => {
                        const language = languages.find((l) =>
                            l.languageCode.trim().includes(val)
                        );
                        if (
                            user &&
                            language &&
                            user.preferredLanguageId !== language.languageId
                        ) {
                            user.preferredLanguageId = language.languageId;
                            return this._auth.updateUser(user);
                        }
                        return EMPTY;
                    })
                )
                .subscribe(() => this._switchLanguage.switch(val));
        } else {
            this._switchLanguage.switch(val);
        }
    }

    signIn() {
        this._authPopup.showSignIn();
    }

    signOut() {
        this.router.navigate(['/sign-out']);
    }
    navigation(route: string) {
        if (route === 'home' && this._providerLink.hasProvider)
            this.router.navigateByUrl(
                `${runtimeConfig.clientCode}/providers/${this._providerLink.providerId}`
            );
        else this.router.navigateByUrl(`${runtimeConfig.clientCode}/${route}`);
    }
}
